import { combineReducers } from 'redux'

import approval from './approval.reducer'
import auth from './auth.reducer'
import common from './common.reducer'
import hr from './hr.reducer'

const reducers = combineReducers({ approval, auth, common, hr })

export type IAppState = ReturnType<typeof reducers>

export default reducers
